import gql from 'graphql-tag'

export default gql`
query getFA_Product($id: ID!) {
	fakturaAssist {
	    getProduct(id: $id) {
	      forSaleDays
	      helfLifeDays
	      consumeDays
	      salesWeight
	    }
	  }
}`
